"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOM_APP_STANDARD_USER_FACING_DATABASE_ROLES = exports.VIEW_CONFIG_MANAGED_BY = exports.CUSTOM_APP_STANDARD_DATABASE_MANAGED_BY_PREFIX = void 0;
exports.resolveCustomAppStandardDatabaseRole = resolveCustomAppStandardDatabaseRole;
exports.isUserFacingCustomAppStandardDatabaseRole = isUserFacingCustomAppStandardDatabaseRole;
exports.isHiddenSystemManagedDatabase = isHiddenSystemManagedDatabase;
const file_index_1 = require("./file-index");
exports.CUSTOM_APP_STANDARD_DATABASE_MANAGED_BY_PREFIX = 'custom-app-standard:';
exports.VIEW_CONFIG_MANAGED_BY = 'view-config';
exports.CUSTOM_APP_STANDARD_USER_FACING_DATABASE_ROLES = [
    'clusters',
    'topics',
    'users',
    'content',
    'forms',
    'submissions',
];
const CUSTOM_APP_STANDARD_USER_FACING_DATABASE_ROLE_SET = new Set(exports.CUSTOM_APP_STANDARD_USER_FACING_DATABASE_ROLES);
function resolveCustomAppStandardDatabaseRole(managedBy) {
    if (typeof managedBy !== 'string')
        return null;
    if (!managedBy.startsWith(exports.CUSTOM_APP_STANDARD_DATABASE_MANAGED_BY_PREFIX)) {
        return null;
    }
    const role = managedBy.slice(exports.CUSTOM_APP_STANDARD_DATABASE_MANAGED_BY_PREFIX.length);
    return role.length > 0 ? role : null;
}
function isUserFacingCustomAppStandardDatabaseRole(role) {
    return CUSTOM_APP_STANDARD_USER_FACING_DATABASE_ROLE_SET.has(role);
}
function isHiddenSystemManagedDatabase(input) {
    const isFileIndex = input.managedBy === file_index_1.FILE_INDEX_MANAGED_BY ||
        (0, file_index_1.isFileIndexDatabaseId)(input.id);
    if (isFileIndex)
        return input.visible !== true;
    if (input.managedBy === exports.VIEW_CONFIG_MANAGED_BY)
        return true;
    const customAppStandardRole = resolveCustomAppStandardDatabaseRole(input.managedBy);
    if (!customAppStandardRole)
        return false;
    return !isUserFacingCustomAppStandardDatabaseRole(customAppStandardRole);
}
